// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2Y9eV","content":"ManualTimeModal_content__y86ZP"};